<template>
  <PrivacySection title="7. Contatti e Ulteriori Informazioni">
    <p>
      Per qualsiasi domanda relativa alla cancellazione dei dati o all'esercizio dei
      tuoi diritti privacy, puoi contattarci:
    </p>
    <PrivacyBox>
      <p><strong>ISIGest S.r.l.</strong></p>
      <p><strong>Email:</strong> <a href="mailto:info@appscontrini.it">info@appscontrini.it</a></p>
      <p><strong>Sito web:</strong> <a href="https://www.appscontrini.it" target="_blank" rel="noopener">www.appscontrini.it</a></p>
    </PrivacyBox>
    <p>
      Per maggiori informazioni sul trattamento dei dati personali, consulta la nostra
      <router-link to="/privacy">Privacy Policy</router-link>.
    </p>
    <p>
      Hai inoltre il diritto di proporre reclamo all'
      <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener">Autorità Garante
      per la Protezione dei Dati Personali</a>.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '@/components/privacy/PrivacySection.vue'
import PrivacyBox from '@/components/privacy/PrivacyBox.vue'

export default {
  name: 'ContactSection',
  components: {
    PrivacySection,
    PrivacyBox
  }
}
</script>
